import React from "react";
import { formatNumber } from "./bootcamp/BootcampTabs";
import Image from "next/image";

export default function AboutInstructor({
  teacherName,
  teacherImage,
  experience,
  studentsTaught,
  reviews,
  teacherDescription,
}: {
  teacherName: string;
  teacherImage: string;
  experience: number;
  studentsTaught: number;
  reviews: number;
  teacherDescription: string;
}) {
  return (
    <div className="flex flex-col md:gap-2 items-start justify-center text-black w-full md:bg-white md:p-[32px] md:rounded-[8px]">
      <div className="flex flex-row items-center justify-center space-x-[32px]">
        <Image
          src={teacherImage || ""}
          width={128}
          height={128}
          priority
          quality={100}
          className="w-full aspect-square max-md:max-w-32 rounded-full object-cover self-start"
          alt="teacher image"
        />
        <div className="flex flex-col justify-center items-center ">
          <p className="font-lato font-medium w-full text-xl mb-1 md:text-left">
            {teacherName}
          </p>
          <div>
            <div className="flex flex-col md:flex-row md:flex-wrap md:gap-x-4 md:items-center mt-0 items-start max-md:justify-center text-[#484848] font-lato">
              {experience ? (
                <div className="flex items-center gap-1 mt-1">
                  <Image
                    width={16}
                    height={16}
                    src="/astro/star-filled.svg"
                    alt="star icon"
                  />
                  <p className="font-lato font-[400] text-[16px] text-nowrap">
                    {experience}+ years of experience
                  </p>
                </div>
              ) : null}
              {studentsTaught ? (
                <div className="flex items-center gap-1">
                  <Image
                    width={16}
                    height={16}
                    src="/astro/star-filled.svg"
                    alt="star icon"
                  />
                  <p className="font-lato text-nowrap">
                    {formatNumber(studentsTaught)}+ students taught
                  </p>
                </div>
              ) : null}
              {reviews ? (
                <div className="flex items-center gap-1">
                  <Image
                    width={16}
                    height={16}
                    src="/astro/star-filled.svg"
                    alt="star icon"
                  />
                  <p className="font-lato text-[16px] text-nowrap">
                    {formatNumber(reviews)}+ reviews (4.85+)
                  </p>
                </div>
              ) : null}
            </div>
            <div className="text-left font-lato font-[400] text-[14px] mt-[14px] hidden md:flex text-[#6E7485] tracking-wider">
              {teacherDescription}
            </div>
          </div>
        </div>
      </div>
      <p className="font-lato text-left text-[16px] font-[400] tracking-wider px-2 mt-4 md:hidden">
        {teacherDescription}
      </p>
    </div>
  );
}
